import React, {Component} from "react";
import regenerator from "regenerator-runtime/runtime";
import ExamViewer from '../../ExamViewer';

class DashboardDoctor extends Component {
    
    constructor(props) {
        super(props);
    }
    
    render() {
        return (
            <ExamViewer examId={null} match={{params: {"examId": null}, isExact: true, path: "", url: ""}} className="h-100"/>
        )
    }
}

export default DashboardDoctor;



// WEBPACK FOOTER //
// ./src/views/Dashboard/doctor/DashboardDoctor.js